export interface OrderPaymentHistory {
    orderPaymentID?: number;
    transaction: string;
    request: string;
    response: string;
    amount: number;
}
